// ===========================================================================
// No Recent Visits — utilidades de formato.
//
// El backend tolera nulos de extremo a extremo (salvo cipId y memberFullName),
// así que todos los helpers degradan a un guion "—" cuando no hay valor.
// ===========================================================================
import { EMPTY_PLACEHOLDER } from "../common/constants";

/** Fecha ISO → "MM/DD/YYYY" (formato local US). "—" si no hay valor. */
export const formatDate = (iso) => {
  if (!iso) return EMPTY_PLACEHOLDER;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return EMPTY_PLACEHOLDER;
  return d.toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });
};

/** Fecha ISO → "MMM d, yyyy" (lectura humana, drawer de detalle). */
export const formatLongDate = (iso) => {
  if (!iso) return EMPTY_PLACEHOLDER;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return EMPTY_PLACEHOLDER;
  return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
};

/** Número con separadores de miles: 10414 → "10,414". "—" si no hay valor. */
export const formatNumber = (value) => {
  if (value == null || Number.isNaN(Number(value))) return EMPTY_PLACEHOLDER;
  return Number(value).toLocaleString("en-US");
};

/** Porcentaje con 1 decimal a partir de parte/total: (9766, 10414) → "93.8%". */
export const formatShare = (part, total) => {
  const p = Number(part);
  const t = Number(total);
  if (!t || Number.isNaN(p) || Number.isNaN(t)) return EMPTY_PLACEHOLDER;
  return `${((p / t) * 100).toFixed(1)}%`;
};

/** Texto "X days ago" a partir de daysSinceVisit. "—" si es null. */
export const formatDaysAgo = (days) => {
  if (days == null || Number.isNaN(Number(days))) return EMPTY_PLACEHOLDER;
  const n = Number(days);
  if (n <= 0) return "Today";
  return `${formatNumber(n)} day${n === 1 ? "" : "s"} ago`;
};

/** Valor seguro: devuelve "—" para null/undefined/string vacío. */
export const safe = (value) =>
  value == null || value === "" ? EMPTY_PLACEHOLDER : value;
